module.exports = __webpack_public_path__ + "img/con1.556aa2aa.png";